export const emailValidator = (email: string) => {
    const regex = /\S+@\S+\.\S+/;
    return regex.test(email);
};

export const capitaliseStartLetter = (label: string) => label.replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase());

export const dotsToDashes = (value: string) => value.replace(/[.]/g, '-');
